import "./RegisterBox.css"
import { useContext, useState } from 'react'
import ProfileContext from '../contexts/ProfileContext';
import RegisterContext from "../contexts/RegisterContext";
import { useNavigate } from "react-router-dom";

function RegisterBox() {
    const route = useNavigate(); // variable to help route to different page

    // variables from ProfileContext that hold data for profile 
    const {profileData, setProfileData} = useContext(ProfileContext);

    // const variable to save credential information
    // variable to track user status
    const {credentials, setCredentials, user, setUser, noMatch, setNoMatch, short, setShort, unique, setUnique} = useContext(RegisterContext);

    // local variable to track repeated password
    const [repeat, setRepeat] = useState('');

    // variable to hold full name
    var fullname = ''

    // variable to hold userID
    var id = 0

    // controls routing to login page 
    const route_login = (e) => {
        setProfileData({...profileData, ['name']: fullname})
        setProfileData({...profileData,['description']: profileData.description})
        setProfileData({...profileData,['username']: credentials.username.toLowerCase()})
        setProfileData({...profileData,['tags']: profileData.tags})
        setProfileData({...profileData,['profile_pic_src']: profileData.profile_pic_src})

        console.log("login")
        setUser(false)
        route("/main/profile")
    }

    //saves first  name to credentials
    const saveFirst = (e) => {
        const text = e.target.value
        setCredentials({ ...credentials, ['first']: text })
    }
    // saves last name to credentials 
    const saveLast = (e) => {
        const text = e.target.value
        setCredentials({ ...credentials, ['last']: text})
    }
    // saves username to credentials 
    const saveUser = (e) => {
        const text = e.target.value 
        setCredentials({...credentials,['username']: text})
        setProfileData({...profileData,['username']: text})
    }
    // saves email to credentials 
    const saveEmail = (e) => {
        const text = e.target.value
        setCredentials({ ...credentials, ['email']: text })
    }
    // saves password to credentials
    const savePassword = (e) => {
        const text = e.target.value
        setCredentials({ ...credentials, ['password']: text })
        //console.log(text)
    }
    // saves repeated password to local variable repeat
    const saveRepeat = (e) => {
        const text = e.target.value
        setRepeat(text)
        //console.log(text)
    }

    // function to validate email 
    const check_email = (e) => {
        var pattern = RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
        var valid = pattern.test(e);
        return valid
    }

    //function to delete user if username is not unique 
    const remove_user = (e) => {
        fetch("https://webdev.cse.buffalo.edu/hci/api/api/deekstra" + "/users/" + sessionStorage.getItem("user") + "?relatedObjectsAction=delete", {
            method: "DELETE",
            headers: {
                'Accept': "*/*",
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
        })
        .then(res => res.json())
        .then(result => {
            if(result){
                console.log("deleting user")
                console.log(result)

                sessionStorage.removeItem("user")
                sessionStorage.removeItem("token")
            }
        },
        error => {
            console.log("error deleting user")
        }
        );
    }

    // function to itterate through users to check username uniqueness 
    const find_user = (e) => {
        fetch("https://webdev.cse.buffalo.edu/hci/api/api/deekstra" + "/users" , {
            method: "GET",
            headers: {
                'Accept': "*/*",
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
            parameters: {
                "username": credentials.username,
            }
        })
        .then(res => res.json())
        .then(result => {
            if(result){
                var resLength = result[0].length  // variable to hold length of result array
                var user_name = false;  // local boolean variable to check if username is unique 
                console.log("users found")
                for(var i = 0 ; i < resLength ; i++){
                    if(result[0][i].id !== id && result[0][i].attributes.username === credentials.username){
                        console.log(result[0][i])
                        setUnique(true);
                        user_name = true;
                        i = resLength;
                    }else{
                        setUnique(false);
                        i++;
                    }
                }
                console.log(unique)
                if(user_name){
                    console.log("username not unique")
                    remove_user();
                }else{
                    console.log("username unique")
                    setUnique(false);
                    route_login();
                }
            }else{
                console.log("something wrong getting users ")
            }
        },
        error => {console.log("error finding user")}
        );
    }

    // controls API call, so makes sure fetch isn't called right away
    const submitHandler = (e) => {
        fetch("https://webdev.cse.buffalo.edu/hci/api/api/deekstra" + "/auth/signup", {
            method: "POST",
            headers: {
                'Accept': "*/*",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: credentials.email,
                password: credentials.password,
                attributes: {
                    name: fullname,
                    username: profileData.username.toLowerCase(),
                    description: profileData.description,
                    tags: profileData.tags,
                    profile_pic_src: profileData.profile_pic_src,
                }
            })
        })
        .then(res => res.json())
        .then(result => {
                if (result.userID){

                    console.log("user signed up");
                    //console.log(result);

                    sessionStorage.setItem("user",result.userID);   // save userID in session
                    sessionStorage.setItem("token",result.token);   // save token in session

                    id = result.userID

                    find_user();
                }else{
                    setUser(true);

                    console.log("user not created");
                    console.log(result);
                }
        },
        error => {
            setUser(true);
        }
        );
    }
    
     // function that control submitHandler and routing
     const submission = (e) => {
        setSelectedFields(p => ({...p, first: "true"}));
        setSelectedFields(p => ({...p, last: "true"}));
        setSelectedFields(p => ({...p, username: "true"}));
        setSelectedFields(p => ({...p, email: "true"}));
        setSelectedFields(p => ({...p, password: "true"}));
        setSelectedFields(p => ({...p, repeat: "true"}));




        var check = check_email(credentials.email)
        setShort(false)
        var pass_length = (credentials.password).length
        if(check){
            if(pass_length > 5){   // pasword must be greater than 5 characters
                if (credentials.password === repeat){

                    fullname = credentials.first + " " + credentials.last;
                    setProfileData({...profileData, ['name']: fullname })
        
                    console.log("passwords match");
                    
                    setNoMatch(false)
                    setUser(false);
        
                    submitHandler(e);
        
                }else{
                    console.log("passwords do not match");
        
                    setNoMatch(true);
                }
            }else{
                console.log("password too short");

                setShort(true)
            }
        }else{
            setUser(true);
        }
    }

    const errorMessages = {
        firstErrors: [],
        lastErrors: [],
        usernameErrors: [],
        emailErrors: [],
        passwordErrors: [],
        repeatErrors: [],
    }
    
    function getErrors() {
        const isEmailValid = check_email(credentials.email);
        const passwordLength = credentials.password.length;
        

            if (credentials.username.length < 1)
                errorMessages.usernameErrors.push(<div className="form-error">Username is required</div>);
            if (credentials.first.length < 1)
                errorMessages.firstErrors.push(<div className="form-error">First name is required</div>);
            if (credentials.last.length < 1)
                errorMessages.lastErrors.push(<div className="form-error">Last name is required</div>);       
            if (credentials.email.length < 1)
                errorMessages.emailErrors.push(<div className="form-error">Email is required</div>);
            if (passwordLength < 5)
                errorMessages.passwordErrors.push(<div className="form-error">Password must be atleast 5 characters</div>);
            if (repeat.length < 1)
                errorMessages.repeatErrors.push(<div className="form-error">Repeat password is required</div>);
            if (!isEmailValid)
                errorMessages.emailErrors.push(<div className="form-error">Email is not valid</div>);
            if (credentials.password !== repeat) {
                errorMessages.passwordErrors.push(<div className="form-error">Passwords do not match</div>);
                errorMessages.repeatErrors.push(<div className="form-error">Passwords do not match</div>);
            }

            console.log("ERROR MESSAGES:\n", errorMessages);
    }
    getErrors();

    const [selectedFields, setSelectedFields] = useState({
        first: "false",
        last: "false",
        username: "false",
        email: "false",
        password: "false",
        repeat: "false",
    });

    return (
        <div className = "LoginBoxBG">
            <div className = "lg-box-header">
                <h1>Register</h1>
            </div>
            <div className = "rg-InputForm">
                <div className="rg-input-wrapper">
                    <label htmlFor="rg-firstname" className="form-input-label">Firstname <span style={{color:'#e63946'}}>*</span></label>
                    <input type="text" required="true" name="rg-firstname" className={(selectedFields.first === "true" && errorMessages.firstErrors.length > 0) ? "rg-input-text-error" : "rg-input-text"} onChange={saveFirst} onBlur={() => setSelectedFields(p => ({...p, first: "true"}))} value = {credentials.first}></input>
                    <div className="form-error">{selectedFields.first === "true" ? errorMessages.firstErrors : null}</div>
                </div>
                <div className="rg-input-wrapper">
                    <label htmlFor="rg-lastname" className="form-input-label">Lastname <span style={{color:'#e63946'}}>*</span></label>
                    <input type="text"  name="rg-lastname" className={(selectedFields.last === "true" && errorMessages.lastErrors.length > 0) ? "rg-input-text-error" : "rg-input-text"} onChange={saveLast} onBlur={() => setSelectedFields(p => ({...p, last: "true"}))} value = {credentials.last}></input>
                    <div className="form-error">{selectedFields.last === "true" ? errorMessages.lastErrors : null}</div>
                </div>
                <div className="rg-input-wrapper">
                    <label htmlFor="rg-username" className="form-input-label">Username <span style={{color:'#e63946'}}>*</span></label>
                    <input type="text"  name="rg-username" className={(selectedFields.username === "true" && errorMessages.usernameErrors.length > 0) ? "rg-input-text-error" : "rg-input-text"} onChange={saveUser} onBlur={() => setSelectedFields(p => ({...p, username: "true"}))} value = {credentials.username}></input>
                    <div className="form-error">{selectedFields.username === "true" ? errorMessages.usernameErrors : null}</div>
                </div>
                <div className="rg-input-wrapper">
                    <label htmlFor="rg-email" className="form-input-label">Email <span style={{color:'#e63946'}}>*</span></label>
                    <input type="text"  name="rg-email" className={(selectedFields.email === "true" && errorMessages.emailErrors.length > 0) ? "rg-input-text-error" : "rg-input-text"} onChange={saveEmail} onBlur={() => setSelectedFields(p => ({...p, email: "true"}))} value = {credentials.email}></input>
                    <div className="form-error">{selectedFields.email === "true" ? errorMessages.emailErrors : null}</div>
                </div>
                <div className="rg-input-wrapper">
                    <label htmlFor="rg-pass1" className="form-input-label">Password <span style={{color:'#e63946'}}>*</span></label>
                    <input type="password"  name="rg-pass1" className={(selectedFields.password === "true" && errorMessages.passwordErrors.length > 0 && selectedFields.repeat === "true") ? "rg-input-text-error" : "rg-input-text"} onChange={savePassword} onBlur={() => setSelectedFields(p => ({...p, password: "true"}))} placeholder="At least 5 characters" value = {credentials.password}></input>
                    <div className="form-error">{selectedFields.password === "true" ? errorMessages.passwordErrors : null}</div>
                </div>
                <div className="rg-input-wrapper">
                    <label htmlFor="rg-pass2" className="form-input-label">Repeat Password <span style={{color:'#e63946'}}>*</span></label>
                    <input type="password" name="rg-pass2" className={(selectedFields.repeat === "true" && errorMessages.repeatErrors.length > 0) ? "rg-input-text-error" : "rg-input-text"} onChange={saveRepeat} onBlur={() => setSelectedFields(p => ({...p, repeat: "true"}))}></input><br/>
                    <div className="form-error">{selectedFields.repeat === "true" ? errorMessages.repeatErrors : null}</div>
                </div>
            </div>
            <div className = "rg-box-footer">
                <button type="submit" className = "reset-button" onClick={submission}>Create Your Account</button>
            </div>
        </div>
    )
}
export default RegisterBox
